<template>
  <slide-out
    dock="right"
    :size="sideOutCurrentSize"
    ref="filterSlideout"
    @resize="OnResize"
    :min-size="sideOutMinSize"
    :allow-resize="nested ? false : true"
    :append-to="nested ? '' : '#app'"
    :visible.sync="slideouts.active"
    v-on:close="onSlideoutClosing">
    <template v-slot:header>
			<h3 v-if="isFetching" class="font-weight-medium pa-1" small>
        <v-progress-circular :size="16" width="2" indeterminate class="mr-1"></v-progress-circular>
        Loading Filters ...
      </h3>
      <h3 v-else class="font-weight-medium pa-1" small><v-icon left>mdi-filter-outline</v-icon> Filters</h3>
      <v-btn @click="closeUpdateSlideout()" icon>
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </template>

    <div class="pa-5">
      <v-progress-linear v-if="isFetching" indeterminate height="2" class="mb-4" />
      <v-alert
        v-if="filterError"
        dense
        outlined
        :type="hasAvailableFilters ? 'warning' : 'error'"
        class="insights-filters-state">
        <span>{{ hasAvailableFilters ? 'Could not refresh filters. Showing previously loaded options.' : 'Could not load anomaly filters.' }}</span>
        <v-btn x-small text :disabled="isFetching" @click="loadFilters">Retry</v-btn>
      </v-alert>
      <v-expansion-panels v-if="hasAvailableFilters" id="insights-filters-panel" multiple>
        <template v-for="(options, filter) in filters">
          <v-expansion-panel v-if="Array.isArray(options) && options.length" :key="filter">
            <v-expansion-panel-header v-ripple>{{ getFilterDisplay(filter) }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-checkbox
                hide-details
                v-for="option in options"
                @change="updateFilters(filter, option)"
                :input-value="Array.isArray(insightsOptions?.filters?.[filter]) && insightsOptions.filters[filter].includes(option)"
                :key="`${filter}-${option}`"
                :label="option ?? getDefaultDisplay(filter)"/>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </template>
      </v-expansion-panels>
      <div v-else-if="!isFetching && !filterError" class="insights-filters-empty" role="status">
        <v-icon>mdi-filter-off-outline</v-icon>
        <p>No filters available for these verified anomalies.</p>
      </div>
    </div>
    <template v-slot:footer>
      <v-card-actions>
        <v-btn text color="error" @click="closeUpdateSlideout()">
          <v-icon left>mdi-chevron-left</v-icon> Close
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn large text color="primary" :disabled="!hasActiveFilters" @click="resetAllFilters()">
          <v-icon left>mdi-filter-remove-outline</v-icon> Clear filters
        </v-btn>
      </v-card-actions>
    </template>
  </slide-out>
</template>

<script>
import { getFilterOptionDisplayName } from '../config/helper';

  export default {
    name: 'edit-user',
    data() {
      return {
        valid: false,
        isFetching: false,
        filterError: null,
        filterRequestVersion: 0,
        selected: {},
        modal: false,
        selectedCemented: {},
        slideouts: {
          active: false,
          isLoading: false,
          isClosing: false,
          hasChanges: false,
        },
      };
    },
    props: {
      nested: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      sideOutMinSize: {
        get() {
          return this.$store.getters['GET_SIDOUT_MINSIZE'];
        },
        set(val) {
          this.$store.commit('SET_SIDOUT_MINSIZE', val);
        },
      },
      sideOutCurrentSize: {
        get() {
          return this.$store.getters['GET_SIDOUT_CURRENTSIZE'];
        },
        set(val) {
          this.$store.commit('SET_SIDOUT_CURRENTSIZE', val);
        },
      },
      insightsOptions: {
        get() {
          return this.$store.getters['AI_INSPECT/GET_OPTIONS'];
        },
        set(val) {
          this.$store.commit('AI_INSPECT/SET_OPTIONS', val);
        },
      },
      filters: {
        get() {
          return this.$store.getters['AI_INSPECT/FILTERS'];
        },
        set(val) {
          this.$store.commit('AI_INSPECT/SET_FILTERS', val);
        },
      },
      hasAvailableFilters() {
        return Object.values(this.filters || {}).some((options) => Array.isArray(options) && options.length);
      },
      hasActiveFilters() {
        const visibleKeys = new Set(Object.keys(this.filters || {}));
        return Object.entries(this.insightsOptions?.filters || {}).some(
          ([key, values]) => visibleKeys.has(key) && Array.isArray(values) && values.length,
        );
      },
    },
    methods: {
      OnResize() {
        let filterSlideout = this.$refs.filterSlideout;
        this.sideOutCurrentSize = filterSlideout.resizeValue;
      },
      onSlideoutClosing() {
        this.$emit('close');
        this.closeUpdateSlideout();
      },
      closeUpdateSlideout() {
        this.filterRequestVersion += 1;
        this.slideouts.active = false;
        this.isFetching = false;
      },
      open() {
        this.slideouts.active = true;
        return this.loadFilters();
      },
      async loadFilters() {
        const requestVersion = ++this.filterRequestVersion;
        this.isFetching = true;
        this.filterError = null;
        try {
          await this.$store.dispatch('AI_INSPECT/GET_FILTERS', {
            facilityId: this.$route.params.id
          });
        } catch (err) {
          if (requestVersion !== this.filterRequestVersion || !this.slideouts.active) return;
          this.filterError = err?.message || 'Please try again.';
          this.$dialog.notify.error('Could not load anomaly filters. Please try again.');
        } finally {
          if (requestVersion === this.filterRequestVersion) this.isFetching = false;
        }
      },
			updateFilters(category, option) {
        const current = Array.isArray(this.insightsOptions?.filters?.[category])
          ? this.insightsOptions.filters[category]
          : [];
        const filters = { ...this.insightsOptions.filters, [category]: [...current] };
        
				if (filters[category]?.includes(option)) {
					filters[category] = filters[category].filter((opt) => opt !== option);
				} else {
					filters[category].push(option);
				}

				this.insightsOptions = {
          ...this.insightsOptions,
          page: 1,
          filters: {
            ...filters,
          }
        };
			},
      getDefaultDisplay(category) {
        switch (category) {
          case 'category':
            return 'Inspection'        
          default:
            return 'Not assigned'
        }
      },
      getFilterDisplay(filter) {
        return getFilterOptionDisplayName(filter);
      },
			resetAllFilters() {
				this.insightsOptions = {
					...this.insightsOptions,
          page: 1,
          filters: {
            ...this.insightsOptions.filters,
            ...Object.fromEntries(Object.keys(this.filters).map((key) => [key, []])),
          }
				};
			},
		},
		created() {
			if (this.nested) {
				this.sideOutCurrentSize = '80vw';
				this.sideOutMinSize = '80vw';
			}
    },
    watch: {
      nested: {
        handler() {
          this.nested ? (this.sideOutCurrentSize = '80vw') : (this.sideOutCurrentSize = '35vw');
          this.nested ? (this.sideOutMinSize = '80vw') : (this.sideOutMinSize = '35vw');
        },
        deep: true,
      },
    },
  };
</script>
<style lang="scss">
  #insights-filters-panel {
    & .v-expansion-panel {
      border: 1px solid #e0e0e0;
      border-radius: 8px;

      &::after {
        border: none;
      }

      &::before {
        box-shadow: none;
      }

      .v-expansion-panel-header {
        height: 40px;
        text-transform: capitalize;
      }
    }

    & .v-input--selection-controls:first-child {
      margin-top: 0;
    }
  }

  .insights-filters-state .v-alert__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
  }

  .insights-filters-empty {
    padding: 24px 8px;
    text-align: center;
    color: var(--v-text_secondary-base);

    p {
      margin: 8px 0 0;
      line-height: 1.5;
    }
  }
</style>
